import React from 'react';
import SelectField from 'components/input/SelectField/SelectField';

const UsesDiscountCodesFilter = <SelectField
    label='filters.components.usesDiscountCodes.label'
    source='uses_discount_codes'
    fullWidth={ true }
    floatingLabelFixed={ true }
    choices={ [
        {
            id: '1',
            name: 'filters.components.usesDiscountCodes.choices.active',
        },
        {
            id: '0',
            name: 'filters.components.usesDiscountCodes.choices.inactive',
        },
    ] }
/>;

export default UsesDiscountCodesFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/UsesDiscountCodesFilter.js